import { render, staticRenderFns } from "./stockBadge.vue?vue&type=template&id=0fd6dc67&scoped=true"
import script from "./stockBadge.vue?vue&type=script&lang=js"
export * from "./stockBadge.vue?vue&type=script&lang=js"
import style0 from "./stockBadge.vue?vue&type=style&index=0&id=0fd6dc67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6dc67",
  null
  
)

export default component.exports